module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/connect/done.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-align-center"
  }, [_vm._v("添加成功")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-153d5e69"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/wifi/Done.vue
// module id = 868
// module chunks = 1